/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_M2_DayInputs */

const cs_enum_m2_day = /** @type {(inputs: Enum_M2_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m² / den`)
};

const en_enum_m2_day = /** @type {(inputs: Enum_M2_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m² / day`)
};

/**
* | output |
* | --- |
* | "m² / day" |
*
* @param {Enum_M2_DayInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_m2_day = /** @type {((inputs?: Enum_M2_DayInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_M2_DayInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_m2_day(inputs)
	return cs_enum_m2_day(inputs)
});